import React, { useCallback } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {setCurrentUser} from "./store/AuthStore";
import SecurityService from "./services/SecurityService";
import AccountApi from "./modules/core/api/AccountApi";
import ContentAuthorized from "./ContentAuthorized";
import ContentUnauthorized from "./ContentUnauthorized";
import { IntlProvider } from 'react-intl'
import { LOCALES } from './i18n/locales';
import { messages } from './i18n/messages'
import { setLocale } from './store/AppStore';

export const App = () => {
    const dispatch = useDispatch();

    const locale = useSelector((state:any) => state.app.locale);

    const [isAuth, setIsAuth] = useState(false);

    const init = useCallback(() => {
        var savedLocale = localStorage.getItem('locale')
        dispatch(setLocale(savedLocale || LOCALES.ENGLISH)) 

        if (null !== SecurityService.getAccessToken()) {
            AccountApi.getCurrentUser().then((data) => {
                dispatch(setCurrentUser(data));
                setIsAuth(SecurityService.isAuth())
            });
        } else {
            dispatch(setCurrentUser(null));
            setIsAuth(false);
        }
    }, [dispatch]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <IntlProvider 
            messages={messages[locale]}
            locale={locale}
            defaultLocale={LOCALES.ENGLISH}>
            {isAuth ? <ContentAuthorized/> : <ContentUnauthorized/>}    
        </IntlProvider>
    )
}
